import React, { Suspense, lazy } from 'react';
import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';
import { connect } from 'react-redux';
import { Router, Route, Redirect, Switch } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import { logoutAndClean } from '../utils/user';
import { clearRedirect } from '../actions/session';
import { onkeyup, onkeydown } from '../actions/shortcut';
import Default from '../Layouts/Default';
import PrivateRoute from './PrivateRoute';
import ConversationPage from '../views/conversation/ConversationPage';
import ScribeLoginProfiling from '../modules/scribe/ScribeLoginProfilingContainer';
import Loading from '../components/Loading';
import ScribeWelcomeContainer from '../modules/scribe/ScribeWelcomeContainer';
const DownloadAppComponent = lazy(() => import(/* webpackChunkName: "appDownload" */ '../components/DownloadAppComponent'));
const BranchRedirectScreen = lazy(() => import(/* webpackChunkName: "branch" */ '../components/BranchRedirectScreen'));
const AppDownloadScreen = lazy(() => import(/* webpackChunkName: "appDownload" */ '../components/AppDownloadScreen'));
const DesktopLoginSuccess = lazy(() => import(/* webpackChunkName: "login" */ '../components/DesktopLoginSuccess'));
const ScribeDashboardContainer = lazy(() => import(/* webpackChunkName: "scribe" */ '../modules/scribe/ScribeDashboard'));
const ScribeConversationsContainer = lazy(() => import(/* webpackChunkName: "scribe" */ '../modules/scribe/ScribeConversationsContainer'));
const Dashboard = lazy(() => import(/* webpackChunkName: "dashboard" */ '../modules/account/pages/dashboard'));
const LicenceBuy = lazy(() => import(/* webpackChunkName: "dashboard" */ '../modules/account/pages/license/buy'));
const Payment = lazy(() => import(/* webpackChunkName: "dasboard" */ '../modules/account/pages/license/payment'));
const PaymentSucceed = lazy(() => import(/* webpackChunkName: "dasboard" */ '../modules/account/pages/payment-succeed'));
const OrganizationCreate = lazy(() => import(/* webpackChunkName: "dasboard" */ '../modules/account/pages/organization/create'));
const AccountStart = lazy(() => import(/* webpackChunkName: "login" */ '../modules/account/pages/start'));
const LinkBuilder = lazy(() => import(/* webpackChunkName: "branch" */ '../modules/account/pages/linkbuilder'));
const AccountSettings = lazy(() => import(/* webpackChunkName: "settings" */ '../modules/account-settings/AccountSettings'));
import Workspace from '../components/Workspace';
const browserHistory = createBrowserHistory();
Sentry.init({
    integrations: [
        new Integrations.BrowserTracing({
            routingInstrumentation: Sentry.reactRouterV5Instrumentation(browserHistory),
        }),
    ],
    tracesSampleRate: 1.0,
    ignoreErrors: ['connection appears to be offline'],
});
window.browserHistory = browserHistory;
class Routes extends React.Component {
    shouldComponentUpdate(nextProps) {
        const { redirectTo: oldRedirectTo } = this.props;
        return nextProps.redirectTo !== oldRedirectTo;
    }
    componentDidMount() {
        // eslint-disable-next-line
        const { onkeydown, onkeyup } = this.props;
        window.document.onkeydown = onkeydown;
        window.document.onkeyup = onkeyup;
    }
    render() {
        var _a;
        // eslint-disable-next-line
        const { clearRedirect, redirectTo, AppWrapper } = this.props;
        if (redirectTo) {
            // clearRedirect causes error "Cannot update component while rendering another component."
            // we delay it with setTimeout
            setTimeout(clearRedirect);
            return (React.createElement(Router, { history: browserHistory },
                React.createElement(Redirect, { to: Object.assign(Object.assign({}, redirectTo), { search: (_a = redirectTo.search) !== null && _a !== void 0 ? _a : window.location.search }) })));
        }
        const scribeAuthenticate = () => {
            const { captioner, features } = this.props;
            return captioner && features && features.scribe;
        };
        const webAppAuthenticate = () => {
            const { avaId } = this.props;
            return avaId && avaId !== '';
        };
        const accountAuthenticate = () => {
            const { accountUser } = this.props;
            return accountUser && !!accountUser.id;
        };
        const isAnonymous = localStorage.getItem('isAnonymous');
        return (React.createElement("div", { id: "gesture" },
            React.createElement(Router, { history: browserHistory },
                React.createElement(AppWrapper, null,
                    React.createElement(Switch, null,
                        React.createElement(Route, { path: "/branch/:branchUrlId", render: (props) => (React.createElement(Suspense, { fallback: React.createElement(Loading, null) },
                                React.createElement(BranchRedirectScreen, Object.assign({}, props)))) }),
                        React.createElement(Route, { path: "/download", render: (props) => (React.createElement(Suspense, { fallback: React.createElement(Loading, null) },
                                React.createElement(AppDownloadScreen, Object.assign({}, props)))) }),
                        React.createElement(Route, { path: "/" },
                            React.createElement(Default, null,
                                React.createElement(Suspense, { fallback: React.createElement(Loading, null) },
                                    React.createElement(Switch, null,
                                        React.createElement(Route, { path: "/workspace", component: Workspace }),
                                        React.createElement(Route, { path: "/account" },
                                            React.createElement(Switch, null,
                                                React.createElement(Route, { exact: true, path: "/account" },
                                                    React.createElement(Redirect, { to: "/account/dashboard" })),
                                                React.createElement(Route, { path: "/account/start", exact: true },
                                                    React.createElement(AccountStart, null)),
                                                React.createElement(Route, { path: "/account/login/profile", render: () => React.createElement(ScribeLoginProfiling, null) }),
                                                React.createElement(Route, { render: (props) => React.createElement(ScribeWelcomeContainer, Object.assign({}, props, { product: "account" })), path: "/account/login" }),
                                                React.createElement(Route, { path: "/account/linkbuilder", exact: true },
                                                    React.createElement(LinkBuilder, null)),
                                                React.createElement(PrivateRoute, { path: "/account/payment-succeed", component: PaymentSucceed, authenticate: accountAuthenticate, redirect: "/account/dashboard" }),
                                                React.createElement(PrivateRoute, { path: "/account/organization/create", component: OrganizationCreate, authenticate: accountAuthenticate, redirect: "/account/dashboard" }),
                                                React.createElement(Route, { path: "/account/dashboard", render: (props) => React.createElement(Dashboard, Object.assign({}, props)) }),
                                                React.createElement(PrivateRoute, { path: "/account/license/buy", component: LicenceBuy, authenticate: accountAuthenticate, redirect: "/account/dashboard", keepPath: true }),
                                                React.createElement(PrivateRoute, { path: "/account/license/payment", component: Payment, authenticate: accountAuthenticate, redirect: "/account/dashboard" }))),
                                        React.createElement(Route, { path: "/web" },
                                            React.createElement(Switch, null,
                                                React.createElement(Route, { path: "/web/login/profile", render: () => React.createElement(ScribeLoginProfiling, null) }),
                                                React.createElement(Route, { exact: true, render: (props) => React.createElement(ScribeWelcomeContainer, Object.assign({}, props, { product: "web" })), path: "/web" }),
                                                React.createElement(Route, { path: "/web/login/desktop", render: (props) => React.createElement(DesktopLoginSuccess, Object.assign({}, props, { product: "web" })) }),
                                                React.createElement(Route, { exact: true, render: (props) => {
                                                        return isAnonymous && isAnonymous === 'true' ? (React.createElement(Redirect, { to: "/web" })) : (React.createElement(ScribeWelcomeContainer, Object.assign({}, props, { product: "web" })));
                                                    }, path: "/web/login" }),
                                                React.createElement(Route, { render: (props) => React.createElement(ScribeWelcomeContainer, Object.assign({}, props, { product: "web" })), path: "/web/login" }),
                                                React.createElement(Route, { render: () => {
                                                        logoutAndClean();
                                                        return React.createElement(Redirect, { to: "/web/login" });
                                                    }, path: "/web/logout" }),
                                                React.createElement(PrivateRoute, { path: "/web/scribe-dashboard", component: ScribeDashboardContainer, authenticate: webAppAuthenticate, redirect: "/web" }),
                                                React.createElement(PrivateRoute, { path: "/web/conversations", component: ScribeConversationsContainer, authenticate: webAppAuthenticate, redirect: "/web" }),
                                                React.createElement(PrivateRoute, { path: "/web/transcript", component: ConversationPage, authenticate: webAppAuthenticate, redirect: "/web" }),
                                                React.createElement(PrivateRoute, { path: "/web/account-settings", component: AccountSettings, authenticate: webAppAuthenticate, redirect: "/web" }))),
                                        React.createElement(Route, { path: "/" },
                                            React.createElement(Switch, null,
                                                React.createElement(Route, { exact: true, component: DownloadAppComponent, path: "/download" }),
                                                React.createElement(Redirect, { to: "/web" }))),
                                        React.createElement(Redirect, { from: "*", to: "/web" }))))))))));
    }
}
const mapStateToProps = ({ scribeSession: { captioner, features, avaId, redirectTo }, scribeConversation: { token }, account: { user: { user: accountUser }, }, currentUser, }) => ({
    avaId: (captioner || {}).avaId || avaId,
    currentUser,
    captioner,
    features,
    token,
    accountUser,
    redirectTo,
});
export default connect(mapStateToProps, {
    onkeydown,
    onkeyup,
    clearRedirect,
})(Routes);
